import { useEffect, useState } from "react";
import styles from "../../../styles/beneficios/BenefitQRCode.module.scss";
import { QRCode } from "../../tools/QRCode";
import { OlgaEnvironmentsAPI } from "../../../providers/OlgaEnvironmentsAPI";
import { Drawer } from "../../components/Drawer";
import { If } from "../../components/control-statements";
import { Button } from "../../components/Button";

export const BenefitQrCode = ({ benefit, visible, onClose }) => {
  const [loading, setLoading] = useState(false);
  const [urlStore, setUrlStore] = useState(false);
  const [qrcode, setQRCode] = useState(false);

  const downloadQrCode = () => {
    QRCode.downloadQRCodeImage(
      `qrcode-${benefit.code}-${benefit.pin}.png`,
      urlStore
    );
  };

  const generateQrCode = async () => {
    const { code, pin } = benefit;
    setLoading(true);
    const { _data } = await OlgaEnvironmentsAPI.getConfigurations(false);
    let urlStore = `${_data['short-urls'].rawShortWallet}?code=${code}&pin=${pin}`;

    if (benefit.brands_valid?.length === 1) {
        urlStore = `${urlStore}&brand=${benefit.brands_valid[0].id}`
    }

    setUrlStore(urlStore);
    setQRCode(await QRCode.getDataUrl(urlStore));
    setLoading(false);
  };

  useEffect(() => {
    if (visible) {
      generateQrCode();
    }
  }, [visible]);

  return (
    <Drawer visible={visible} onClose={onClose} closeInFade title="QR Code">
      <div className={styles["qrcode-container"]}>
        <If cond={!loading && qrcode}>
          <div className={styles.qrcode}>
            <img
              src={qrcode}
              className={`${styles["img-fluid"]} ${styles.mobile}`}
              alt="Integrações"
              id="qrcode-image"
            />
            <p className={styles.url}>{urlStore}</p>
            <Button onClick={downloadQrCode}>Salvar QR Code</Button>
            <Button className="mt-10" onClick={printQrCode}>
              Imprimir QR Code
            </Button>
          </div>
        </If>
      </div>
    </Drawer>
  );
};

const printQrCode = () => {
  const iframe = document.createElement("iframe");
  // Make it hidden
  iframe.style.height = 0;
  iframe.style.visibility = "hidden";
  iframe.style.width = 0;

  // Set the iframe's source
  iframe.setAttribute("srcdoc", "<html><body></body></html>");

  document.body.appendChild(iframe);

  iframe.addEventListener("load", function () {
    // Clone the image
    const image = document.getElementById("qrcode-image").cloneNode();
    image.style.maxWidth = "100%";

    // Append the image to the iframe's body
    const body = iframe.contentDocument.body;
    body.style.textAlign = "center";
    body.appendChild(image);

    image.addEventListener("load", function () {
      // Invoke the print when the image is ready
      iframe.contentWindow.print();
    });
  });
};
